import { RootState } from '../../index';

export const getSafelistSummaryMap = (state: RootState) => state.safelists.safelistSummaries;

export const getSafelistToEdit = (state: RootState) => state.safelists.safelistToEdit;

export const getIsAddingSafelistFlag = (state: RootState) => state.safelists.isAddingSafelist;

export const getIsDeletingSafelistFlag = (state: RootState) => state.safelists.isDeletingSafelist;

export const getIsDeletingSafelistTermFlag = (state: RootState) => state.safelists.isDeletingSafelistTerm;

export const getExtractedTerms = (state: RootState) => state.safelists.extractedTerms;
